module.exports = __webpack_public_path__ + "static/media/29COICT4.cb0312ec.jpg";